import { createFileRoute, Outlet } from "@tanstack/react-router";

import SettingsLayout from "@/layouts/settings/SettingsLayout";

export const Route = createFileRoute("/_secure/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}
